import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledHeroImage = styled.div`
    background-repeat: no-repeat;
    background-size: cover;
    height: ${({ height }) => height};
    width: 100%;
`;
const HeroImage = ({ url, children, height, className }) => (
    <StyledHeroImage url={url} height={height} className={className}>
        {children}
    </StyledHeroImage>
);
HeroImage.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string,
    children: PropTypes.node,
    height: PropTypes.string,
};
export default HeroImage;
